import api from "./index";

export const envApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getEnvList: builder.query<EnvVariable[], void>({
            query: () => ({
                url: `env`,
                method: "get",
            }),
            transformResponse: (response: DefaultResponse<EnvVariable[]>) => response.data,
            providesTags: (_result, _error) => ["env"],
        }),
        setEnvVar: builder.mutation<DefaultResponse<{ success: boolean, key: string, value: any }>, { key: string, value: any }>({
            query: (data) => ({
                url: `env`,
                method: "post",
                data: { key: data.key, value: data.value },
            }),
            invalidatesTags: (_result, _error) => ["env"],
        }),
    }),
});

export const { useGetEnvListQuery, useSetEnvVarMutation, } = envApi;